import React from "react";

const DownloadIcon = ({ color = "white" }: { color?: string }) => {
	return (
		<svg
			width="12"
			height="15"
			viewBox="0 0 12 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.179688 13H11.8203V14.6797H0.179688V13ZM11.8203 5.5L6 11.3203L0.179688 5.5H3.5V0.5H8.5V5.5H11.8203Z"
				fill={color}
			/>
		</svg>
	);
};

export default DownloadIcon;
